<template>
  <div>
    <CRow class="top-content">
      <CCol sm="6">
        <CCard>
          <CCardHeader
              class="d-flex justify-content-between align-items-center"
          >
            اطلاعات دانش‌آموز
          </CCardHeader>

          <CCardBody
              class="
              d-flex
              flex-column
              justify-content-center
              align-items-start
              h-100
            "
          >
            <div class="user-spec mb-3">
              <div class="user-spec__title bold">نام:</div>
              {{ student.name }}
            </div>
            <div class="user-spec mb-3">
              <div class="user-spec__title bold">نام خانوادگی:</div>
              {{ student.lastname }}
            </div>
            <div class="user-spec mb-3">
              <div class="user-spec__title bold">شماره‌ی تماس:</div>
              {{ student.mobile }}
            </div>
            <div class="user-spec mb-3">
              <div class="user-spec__title bold">کد ملی:</div>
              {{ student.nationalId }}
            </div>
            <div class="user-spec mb-3">
              <div class="user-spec__title bold">نام پدر:</div>
              {{ student.fatherName }}
            </div>
            <div class="user-spec mb-3">
              <div class="user-spec__title bold">تاریخ تولد:</div>
              {{ birthDate }}
            </div>
            <div class="user-spec mb-3">
              <div class="user-spec__title bold">شماره‌ی کلاس:</div>
              {{ student.klass.name }}
            </div>
            <div class="user-spec mb-3">
              <div class="user-spec__title bold">پایه:</div>
              {{ student.klass.grade.name }}
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="6">
        <CCard>
          <CCardHeader
              class="w-100 d-flex justify-content-between align-items-center"
          >
            اطلاع رسانی
          </CCardHeader>

          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
                :fields="studentAlertFields"
                :items="computedStudentAlerts"
                :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
                border
                class="w-100 d-flex justify-content-between h-100"
                fixed
                hover
                small
                striped
            >
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader
              class="w-100 d-flex justify-content-between align-items-center"
          >
            ارزشیابی ها
          </CCardHeader>
          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
                :fields="studentMarksField"
                :items="computedStudentMarks"
                :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
                border
                class="w-100 d-flex justify-content-between h-100"
                fixed
                hover
                small
                striped
            >
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  name: "studentAlert",
  data() {
    return {
      studentAlertFields: [
        {key: "text", label: "مورد انضباطی"},
        {key: "computedDate", label: "تاریخ"},
        {key: "managerName", label: "توسط"},
      ],
      studentMarksField: [
        {key: "courseName", label: "درس"},
        {key: "examName", label: "عنوان"},
        {key: "computedDate", label: "تاریخ"},
        {key: "markString", label: "نمره/شاخص"},
        {key: "rank", label: "رتبه"},
        {key: "text", label: "گزارش عملکرد"},
      ],
      loading: false,
      studentAlerts: [],
      student: {},
      studentMarks: [],
    };
  },
  computed: {
    computedStudentAlerts() {
      return this.studentAlerts.map((item) => {
        return {
          ...item,
          computedDate: item.date.replaceAll("-", "/"),
          managerName: `${item.manager.name} ${item.manager.lastname}`,
        };
      });
    },
    computedStudentMarks() {
      return this.studentMarks.map((item) => {
        return {
          ...item,
          courseName: this.getcourseName(item).toString(),
          examName: item.exam.title,
          computedDate: item.addDate.replaceAll("-", "/"),
          // examAverageMark: item.exam.averageMark,
        };
      });
    },
    birthDate() {
      return this.student.birthDate.replaceAll("-", "/");
    },
  },
  mounted() {
    this.getStudentAlerts();
    this.getStudent();
    this.getStudentMarks();
  },
  methods: {
    getcourseName(item) {
      let name = "";
      for (let i = 0; i < item.exam.courses.length; i++) {
        name += `${item.exam.courses[i].name} ${item.exam.courses[i].klass.grade.name} ${item.exam.courses[i].klass.name}`;
        if (i < item.exam.courses.length - 1) {
          name += "، ";
        }
      }
      return name;
    },
    async getStudentAlerts() {
      try {
        this.loading = true;
        const {data} = await axios.get(`/student/${this.$userId}/alert`);
        this.studentAlerts = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getStudentMarks() {
      try {
        this.loading = true;
        const payload = {
          studentId: this.$userId,
        };
        const {data} = await axios.get("/mark", {params: {...payload}});
        this.studentMarks = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getStudent(routeName) {
      try {
        this.loading = true;
        const {data} = await axios.get(`/student/${this.$userId}`);
        this.student = data;
        routeName = `${data.name} ${data.lastname}`;
        this.$emit("go-to", routeName);
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: calc(100% - 24px);
}

.user-spec {
  display: flex;

  &__title {
    min-width: 100px;
  }
}
</style>